import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row q-mb-lg justify-between" }
const _hoisted_2 = { class: "col-8" }
const _hoisted_3 = { class: "col-4 packages--checkbox" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "scroll packages--selection"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_q_input, {
          label: "Filter by name",
          outlined: "",
          dense: "",
          modelValue: _ctx.filter,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_q_checkbox, {
          modelValue: _ctx.showOnlySelectedPackages,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showOnlySelectedPackages) = $event)),
          "left-label": "",
          label: "Show only selected"
        }, null, 8, ["modelValue"])
      ])
    ]),
    (!_ctx.filteredPackages.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, "No matched packages"))
      : _createCommentVNode("", true),
    (_ctx.filteredPackages.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_q_list, { dense: "" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredPackages, (packageItem) => {
                return (_openBlock(), _createBlock(_component_q_item, {
                  class: "package-item",
                  clickable: "",
                  key: `package-${packageItem.value}`
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_section, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(packageItem.label), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_q_item_section, { side: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_checkbox, {
                          modelValue: _ctx.localModel,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localModel) = $event)),
                          val: packageItem.value
                        }, null, 8, ["modelValue", "val"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}